module.exports = __webpack_public_path__ + "img/Image2.720b6358.png";